import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';
import {
  emptyStructuredJsonItem,
  parseStructuredJsonArray,
  serializeStructuredJsonArray,
  structuredJsonItemFromPayload
} from '../../shared/design-system/structured-json-form.utils';

export const REINSURANCE_TREATY_TYPE_OPTIONS = [
  { value: 'QuotaShare', labelKey: 'insurance.reinsurance.treatyTypes.quotaShare' },
  { value: 'Surplus', labelKey: 'insurance.reinsurance.treatyTypes.surplus' },
  { value: 'XOL', labelKey: 'insurance.reinsurance.treatyTypes.xol' }
] as const;

export const REINSURANCE_TREATY_STATUS_OPTIONS = [
  { value: 'Active', labelKey: 'insurance.reinsurance.treatyStatus.active' },
  { value: 'Inactive', labelKey: 'insurance.reinsurance.treatyStatus.inactive' }
] as const;

export const REINSURANCE_TREATY_LAYER_FIELDS: StructuredJsonFieldDef[] = [
  {
    key: 'layerNumber',
    type: 'number',
    labelKey: 'insurance.reinsurance.schemas.layer.layerNumber'
  },
  {
    key: 'limit',
    type: 'number',
    labelKey: 'insurance.reinsurance.schemas.layer.limit',
    required: true
  },
  {
    key: 'attachment',
    type: 'number',
    labelKey: 'insurance.reinsurance.schemas.layer.attachment'
  },
  {
    key: 'cessionPercent',
    type: 'number',
    labelKey: 'insurance.reinsurance.schemas.layer.cessionPercent'
  }
];

export const REINSURANCE_PROGRAM_LINE_OF_BUSINESS_OPTIONS = [
  { value: 'motor', label: 'Motor' },
  { value: 'property', label: 'Property' },
  { value: 'life', label: 'Life' },
  { value: 'health', label: 'Health' },
  { value: 'liability', label: 'Liability' },
  { value: 'marine', label: 'Marine' },
  { value: 'credit', label: 'Credit' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'travel', label: 'Travel' },
  { value: 'group', label: 'Group' },
  { value: 'reinsurance', label: 'Reinsurance' }
] as const;

export function parseTreatyLayersJson(json: string): Record<string, unknown>[] {
  return parseStructuredJsonArray(json);
}

export function serializeTreatyLayersJson(items: Record<string, unknown>[]): string {
  return serializeStructuredJsonArray(REINSURANCE_TREATY_LAYER_FIELDS, items);
}

export function emptyTreatyLayerItem(): Record<string, unknown> {
  return emptyStructuredJsonItem(REINSURANCE_TREATY_LAYER_FIELDS);
}

export function treatyLayerItemFromPayload(payloadJson: string): Record<string, unknown> {
  return structuredJsonItemFromPayload(REINSURANCE_TREATY_LAYER_FIELDS, payloadJson);
}

export function treatyLayerSummary(item: Record<string, unknown>): string {
  const layerNumber = item['layerNumber'];
  const limit = item['limit'];
  const attachment = item['attachment'];
  const parts = [
    layerNumber !== null && layerNumber !== undefined && layerNumber !== '' ? `#${layerNumber}` : '',
    limit !== null && limit !== undefined && limit !== '' ? `limit ${limit}` : '',
    attachment !== null && attachment !== undefined && attachment !== '' ? `attach ${attachment}` : ''
  ].filter(Boolean);
  return parts.join(' · ') || '-';
}

export function treatyTypeLabelKey(value: string): string {
  const option = REINSURANCE_TREATY_TYPE_OPTIONS.find(item => item.value === value);
  return option?.labelKey ?? 'insurance.reinsurance.treatyTypes.other';
}

export function treatyStatusLabelKey(value: string): string {
  const option = REINSURANCE_TREATY_STATUS_OPTIONS.find(item => item.value === value);
  return option?.labelKey ?? 'insurance.reinsurance.treatyStatus.other';
}
